import { render, staticRenderFns } from "./TaskUserSelect.vue?vue&type=template&id=3e8dd906&scoped=true&"
import script from "./TaskUserSelect.vue?vue&type=script&lang=js&"
export * from "./TaskUserSelect.vue?vue&type=script&lang=js&"
import style0 from "./TaskUserSelect.vue?vue&type=style&index=0&id=3e8dd906&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e8dd906",
  null
  
)

export default component.exports